import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {FolderTypes} from "./Folder";
import {Upload} from "./Upload";

export enum DocumentTypes {
	Undefined = 'undefined',
	EmployeeContract = 'employee_contract',
	Invoice = 'invoice',
	Predracun = 'predracun',
	AvansniRacun = 'avansni_racun',
	Racun = 'racun',
	PoslovniUgovor = 'poslovni_ugovor',
	UgovorORadu = 'ugovor_o_radu',
	AneksUgovora = 'aneks_ugovora',
	ZaKabinet = 'dokument_za_kabinet',
	InoFaktura = 'ino_faktura',
	RacunZaProviziju = 'racun_za_proviziju',
	ObracunProvizije = 'obracun_provizije',
	ZahtevZaPovratSredstavaPotpun = 'zahtev_za_povrat_potpun',
	PredlogZaSaradnju = 'predlog_za_saradnju',
	AneksUgovoraORadu = 'aneks_ugovora_o_radu',
	RaskidUgovoraORadu = 'raskid_ugovora_o_radu',
	Kompenzacija = 'kompenzacija',
	Otpremnica = 'otpremnica',
	ZahtevZaRaskidPolise = 'zahtev_za_raskid_polise',
	ZahtevZaPrenosSredstava = 'zahtev_za_prenos_sredstava',
	Ponuda = 'ponuda',
	ZapisnikOZavrsenomPoslu = 'zapisnik_o_zavrsenom_poslu',
	PotvrdaOIzvrsenojPrijaviStete = 'potvrda_o_izvrsenoj_prijavi_stete',
	PrigovorZaStetu = 'prigovor_za_stetu',
	ZakljucakJavnogIzvrsitelja = 'zakljucak_javnog_izvrsitelja',
	OpomenaZaSudskeTakse = 'opomena_za_sudske_takse',
	ZahtezZaSanivanjeRadnogOdnosa = 'zahtev_za_zasnivanje_radnog_odnosa',
	IzvodOtvorenihStavki = 'izvod_otvorenih_stavki',
	PotvrdaOSprecenostiZaRad = 'potvrda_o_sprecenosti_za_rad',
	ZahtevZaOdsustvovanje = 'zahtev_za_odsustvovanje',
	IzvestajEksterneRevizije = 'izvestaj_eksterne_revizije'
}

export class Document extends BaseModel {

	id: string
	parentId: string
    title: string
	info: string
	type: string
    fields: any
	actions: any
	assignedTo: string
	state: string
	tags: any
	visibleTo: any
	indexingNumber: string
	indexingDate: string
	notAllowed: boolean = false
	financialStatus?: string // derived for special usage

	public static generateNotAllowed () {
		let document = new Document()
		document.notAllowed = true
		return document
	}

	public static getTitle(document: Document) {
		switch (document.type) {
			case DocumentTypes.EmployeeContract:
				return `Ugovor o radu - ${document.fields? document.fields.id : ''}`
			case DocumentTypes.Predracun:
				return `Predrаčun - ${document.fields? document.fields.indexingNumber : ''}`
			case DocumentTypes.Racun:
				return `Rаčun - ${document.fields? document.fields.indexingNumber : ''}`
			case DocumentTypes.AvansniRacun:
				return `Avansni račun - ${document.fields? document.fields.indexingNumber : ''}`
			case DocumentTypes.PoslovniUgovor:
				return `Ugovor - ${document.fields? document.fields.indexingNumber : ''}`
			case DocumentTypes.AneksUgovora:
				return `Aneks ugovora - ${document.fields? document.fields.indexingNumber : ''}`
			case DocumentTypes.UgovorORadu:
				return `Ugovor o radu - ${document.fields? document.fields.indexingNumber : ''}`
			default:
				return `${document.type} - ${document.indexingNumber? document.indexingNumber : ''}`
		}
		return document.title
	}


}


